
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { propTypes, reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import compose from 'recompose/compose';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';




import { Card, CardActions } from 'material-ui/Card';
import Avatar from 'material-ui/Avatar';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import LockIcon from 'material-ui/svg-icons/action/lock-outline';
import { cyan500, pinkA200 } from 'material-ui/styles/colors';

import { Notification, translate, userLogin as userLoginAction,required,email } from 'admin-on-rest';


const styles = {
    main: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
    },
    card: {
        minWidth: 300,
    },
    avatar: {
        margin: '1em',
        textAlign: 'center ',
    },
    form: {
        padding: '0 1em 1em 1em',
    },
    input: {
        display: 'flex',
    },
    hint: {
        textAlign: 'center',
        marginTop: '1em',
        color: '#ccc',
    },
    button:
    {
        marginLeft: '8em',
        marginRight:'auto',
    }
};


function getColorsFromTheme(theme) {
    if (!theme) return { primary1Color: cyan500, accent1Color: pinkA200 };
    const {
        palette: {
            primary1Color,
            accent1Color,
        },
      } = theme;
    return { primary1Color, accent1Color };
}

// see http://redux-form.com/6.4.3/examples/material-ui/
const renderInput = ({ meta: { touched, error } = {}, input: { ...inputProps }, ...props }) =>
    <TextField
        errorText={touched && error}
        {...inputProps}
        {...props}
        fullWidth
    />;


class Login extends Component {
   login = ({ username, password }) => {
        const { userLogin, location } = this.props;
        userLogin({ username, password }, location.state ? location.state.nextPathname : '/');
    }

 

    render() {
        const { handleSubmit, submitting, theme, translate } = this.props;
        
        const muiTheme = getMuiTheme(theme);
        const { primary1Color, accent1Color } = getColorsFromTheme(muiTheme);
        return (
            <MuiThemeProvider muiTheme={muiTheme}>
                <div style={{ ...styles.main, backgroundColor: primary1Color }}>
                    <Card style={styles.card}>
                        <div style={styles.avatar}>
                            <img src="logo.svg"/>
                            
                        </div>

                        <form onSubmit={handleSubmit(this.login)}>
                            <div style={styles.form}>
                                
                                <div style={styles.input} >
                                    <Field
                                        name="username"
                                        component={renderInput}
                                        
                                        floatingLabelText={translate('aor.auth.username')}
                                        validate={[ required, email ]}
                                    />
                                </div>
                                <div style={styles.input}>
                                    <Field
                                        name="password"
                                         
                                        component={renderInput}
                                        floatingLabelText={translate('aor.auth.password')}
                                        type="password"
                                         validate={[ required ]}
                                    />
                                </div>
                            </div>
                            <CardActions>
                                <RaisedButton style={styles.button} type="submit" primary disabled={submitting} label={translate('aor.auth.sign_in')} fullWidth />
                            </CardActions>
                        </form>
                    </Card>
                      <Notification />
                </div>
            </MuiThemeProvider>
        );
    }
}
Login.propTypes = {
    ...propTypes,
    authClient: PropTypes.func,
    previousRoute: PropTypes.string,
    theme: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
};



Login.defaultProps = {
    theme: {},
};

 
const enhance = compose(
    translate,
    reduxForm({
        form: 'signIn',
     
    }),
    connect(null, { userLogin: userLoginAction }),
);

export default enhance(Login);



// WEBPACK FOOTER //
// ./src/Login.js